import ReactComponent from './bookmark-filled.svg?react'
import overridable from '../../utils/overridable'

export default overridable('BookmarkFilledIcon')(ReactComponent)
